import React, { Component, Fragment } from 'react';
import { useQuery, useMutation } from '@apollo/react-hooks';
import { gql } from 'apollo-boost';
import { Link } from 'react-router-dom'

import { ADD_TO_CART } from './category';
import { USER_CART_ITEMS } from './cart';
import Header from '../components/header';
import Footer from '../components/footer';
import requireAuth from '../requireAuth';
import shades from '../assets/shades.jpg';
import Spinner from 'react-spinkit';

const USER_PRODUCTS = gql`
  query USER_PRODUCTS {
    getUserProducts{
      id
      name
      price
      description
      image_url
      category{
        id
        name
      }
    }
  }
`;

const DELETE_PRODUCT = gql`
  mutation deleteProduct($productId: String) {
    deleteProduct(productId: $productId){
      id
      name
      description
      price
      image_url
      category {
        id
        name
      }
    }
  }
`;
const Shop = (props) => {
  const [addToCart, { loading: mutationLoading }] = useMutation(ADD_TO_CART);
  const [deleteProduct, { loading: removeMutationLoading }] = useMutation(DELETE_PRODUCT);

  const removeProduct = async (productId) => {
    try {
      // console.log(productId);
      const response = await deleteProduct({
        variables: {
          productId
        },
        update: (cache, { data: { deleteProduct } }) => {
          const data = cache.readQuery({ query: USER_PRODUCTS });
          const index = data.getUserProducts.findIndex(product => {
            return product.id === deleteProduct.id
          });
          if (index !== -1) {
            data.getUserProducts.splice(index, 1);
          }
          cache.writeQuery({ query: USER_PRODUCTS, data });
        }
      });
      console.log(response);
    } catch (error) {
      console.log(error.message);
    }
  }

  const addItemToCart = async (product) => {
    try {
      const response = await addToCart({
        variables: {
          productId: product.id,
          quantity: 1
        },
        update: (cache, { data: { addToCart } }) => {
          const data = cache.readQuery({ query: USER_CART_ITEMS });
          const index = data.cart.findIndex(item => {
            return item.id === addToCart.id
          });
          if (index !== -1) {
            data.cart.map(item => {
              if (item.id === addToCart.id) {
                item.quantity += 1;
              }
            })
          } else {
            data.cart.push(addToCart);
          }
          cache.writeQuery({ query: USER_CART_ITEMS, data });
        }
      });
      console.log('cart-response', response.data);
    } catch (err) {
      console.log(err.message);
    }
  }

  const { loading, error, data } = useQuery(USER_PRODUCTS);
  if (loading) return (<Spinner name="circle" />);
  if (error) return 'error';

    return (
      <Fragment>
        <Header></Header>
        <section className="shop">
          {
            data.getUserProducts.map((product) => {
              return (
                <div key={product.id} className="shop__product-card">
                  <figure>
                    <img src={product.image_url} alt="shop" className="shop__img" />
                  </figure>
                  <p className="shop__name"><Link to={`/single/${product.id}`}>{product.name}</Link></p>
                  <p className="shop__price">${product.price}</p>
                  <ul className="shop__cta">
                    <li><Link to={`/update/${product.id}`}>Edit</Link></li>
                    <li><a onClick={() => addItemToCart(product)}>Add{mutationLoading && 'ing'} To Cart</a></li>
                    <li><a onClick={() => removeProduct(product.id)}>Delete This Item {'loading' && removeMutationLoading}</a></li>
                  </ul>
                </div>
              )
            })
          }

        </section>
        <Footer></Footer>
      </Fragment>
    )
}
export default requireAuth(Shop);
export { USER_PRODUCTS };